import React from "react";
import HappyCustomer from '../img/happy-customer.png';
import stockImg from '../img/invest.JPG';
import task from '../img/task app.JPG';
import foodappimg from '../img/food app.jpg';
import furnitureappimg from '../img/furniture.jpg';
import blockchain from '../img/blockchain.png';
import graphics from '../img/graphics.png';
import growth from '../img/growth.png';
import leader from '../img/leader.png';
import ui from '../img/ux.png';
import website from '../img/website.png';
import socialmedia from '../img/social-media.png';
import sales from '../img/sales.png';
import mobile from '../img/mobile.png';


const Home = () => {
  return (
    <>
      <section id='home_section1' data-aos="zoom-in-up">
        <article className="head_title">
          <p className="head_para_1">Get quality<br/>
            digital services<br/>
            you really want
          </p>
          <p className="head_para_2">
           Our motto is to fulfil customer demand by making<br/>
            them satisfied with growing their business
          </p>
          <div className="get_started">Get Started</div>
        </article>
        <article className="head_img">
          <img src={HappyCustomer} alt="Happy Customer"/>
        </article>
      </section>

      <section id='home_section2' data-aos="zoom-in-up">
        <p className="what-we-do">What We Do</p>
        <article className="what-we-do-title">
          Perfect Solution For <br/>
          Your Business
        </article>
        <article className="what-we-do-description">
          As our motto, we always provide the best service<br/>
          especially for you and your company by growing your<br/>
          company to be better
        </article>
        <div id="benefit_wrapper">
          <article className="benefit-1" data-aos="fade-left">
            <div className="box1">
              <img  src={growth}/>
            </div>
            <strong>Grow Your Business</strong>
            <p>We always help your company<br/>
              to grow with us.
            </p>
          </article>
          <article className="benefit-2" data-aos="fade-left">
            <div className="box2">
              <img  src={sales}/>
            </div>
            <strong>Drive More Sales</strong>
            <p>
              Every company that we handle,<br/>
              we always drive more sales.
            </p>
          </article>
          <article className="benefit-3" data-aos="fade-left">
            <div className="box3">
              <img  src={leader}/>
            </div>
            <strong>Handled By Expert</strong>
            <p>
              You dont need to worry because<br/>
              we are professionals.
            </p>
          </article>
        </div>
      </section>

      <section id="home_services" data-aos="zoom-in-up">
        <p className="our_services">Our Services</p>
        <p className="save-time">
          Save Time Managing your business<br/>
          with our best services
        </p>
        <article className="service_1" data-aos="fade-left">
          <div className="ser1">
            <img src={website} />
          </div>
          <strong>Web Development</strong>
        </article>
        <article className="service_2" data-aos="fade-left">
          <div className="ser2">
            <img src={socialmedia} />
          </div>
          <strong>
            Digital Marketing
          </strong>
        </article>
        <article className="service_3" data-aos="fade-left">
          <div className="ser3">
            <img src={graphics} />
          </div>
          <strong>
            Graphic Design
          </strong>
        </article>
        <article className="service_4" data-aos="fade-left">
          <div className="ser4">
            <img src={mobile} />
          </div>
          <strong>
            App Development
          </strong>
        </article>
        <article className="service_5" data-aos="fade-left">
          <div className="ser5">
            <img src={ui} />
          </div>
          <strong>
            UI/UX Design<br/>
            Services
          </strong>
        </article>
        <article className="service_6" data-aos="fade-left">
          <div className="ser6">
            <img src={blockchain} />
          </div>
          <strong>
            Blockchain Development
          </strong>
        </article>
      </section>

      <section id="casestudy" data-aos="zoom-in-up">
        <p className="case-study-head">CASE STUDIES</p>
        <article className="case1" data-aos="fade-left">
          <div className="case1-img">
             <img src={stockImg} alt="Stock App Img"/>
          </div>
          <div className="case1-writeup-holder">
            <h2>Stock Investment App</h2>
            <p>
              This is an investment app that invest,<br/> 
              reinvest and trade securities for their clients
            </p>
          </div>
        </article>
        <article className="case2" data-aos="fade-left">
          <div className="case2-img">
             <img src={task} alt="Task App Img"/>
          </div>
          <div className="case1-writeup-holder">
            <h2>Task Management App</h2>
            <p>
              This is a task management application that can help<br/>
              you be more productive by scheduling important<br/>
              things that you want to do today<br/>
            </p>
          </div>
        </article>
        <article className="case2" data-aos="fade-left">
          <div className="case2-img">
             <img src={foodappimg} alt="Food App Img"/>
          </div>
          <div className="case1-writeup-holder">
            <h2>Food Delivery App</h2>
            <p>
              This is a food delivery app with a fun and modern<br/>
              theme according to the wishes of our clients and<br/>
              this is the result we provide with a fresh and <br/>
              modern look.
            </p>
          </div>
        </article>
        <article className="case1" data-aos="fade-left">
          <div className="case1-img">
             <img src={furnitureappimg} alt="Furniture App Img"/>
          </div>
          <div className="case1-writeup-holder">
            <h2>Furniture App</h2>
            <p>
              This is a furniture landing page for our client with a<br/>
              modern and classic theme which is useful for their<br/>
              furniture sales website.
            </p>
          </div>
        </article>
      </section>
    </>
  );
};
export default Home;
